import React from 'react'

const InventoryManageIcon = () => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={50}
                height={50}
                x={0}
                y={0}
                viewBox="0 0 512 512"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
            >
                <g>
                    <path
                        fill="#ffc751"
                        d="M251.626 432.804H144.444a6.565 6.565 0 0 1-6.565-6.565V319.058a6.565 6.565 0 0 1 6.565-6.565h107.182a6.565 6.565 0 0 1 6.565 6.565V426.24a6.565 6.565 0 0 1-6.565 6.564z"
                        opacity={1}
                        data-original="#ffc751"
                    />
                    <path
                        fill="#ffaf40"
                        d="M258.188 338.866v87.369c0 3.628-2.935 6.574-6.562 6.574h-91.239c48.455-8.932 86.987-46.169 97.801-93.943z"
                        opacity={1}
                        data-original="#ffaf40"
                    />
                    <path
                        fill="#b55434"
                        d="M241.15 335.906v73.484a6.373 6.373 0 0 1-6.373 6.373h-73.484a6.373 6.373 0 0 1-6.373-6.373v-73.484a6.373 6.373 0 0 1 6.373-6.373h73.484a6.373 6.373 0 0 1 6.373 6.373z"
                        opacity={1}
                        data-original="#b55434"
                    />
                    <path
                        fill="#7f392c"
                        d="M241.15 335.906v73.484a6.373 6.373 0 0 1-6.373 6.373h-44.342c24.286-15.152 40.446-42.11 40.446-72.842 0-4.554-.355-9.026-1.039-13.387h4.934a6.371 6.371 0 0 1 6.374 6.372z"
                        opacity={1}
                        data-original="#7f392c"
                    />
                    <path
                        fill="#a1412b"
                        d="M229.843 329.533h-68.549a6.373 6.373 0 0 0-6.373 6.373v2.124h51.932c5.297 0 9.529 4.448 9.219 9.735l-.007.109c-2.288 33.27-27.451 60.251-59.878 65.326v.002a6.36 6.36 0 0 0 5.107 2.56h29.142c24.286-15.152 40.446-42.11 40.446-72.842a86.486 86.486 0 0 0-1.039-13.387z"
                        opacity={1}
                        data-original="#a1412b"
                    />
                    <path
                        fill="#ff8f33"
                        d="M241.145 335.908v10.213l-6.181 6.181-57.26 57.271-6.193 6.193h-10.213a6.376 6.376 0 0 1-6.378-6.378v-10.225l69.634-69.634h10.225a6.376 6.376 0 0 1 6.366 6.379z"
                        opacity={1}
                        data-original="#ff8f33"
                    />
                    <path
                        fill="#ffaf40"
                        d="m234.964 352.303-57.26 57.271a42.31 42.31 0 0 1-16.603-16.591l57.271-57.271a42.42 42.42 0 0 1 16.592 16.591z"
                        opacity={1}
                        data-original="#ffaf40"
                    />
                    <path
                        fill="#fff370"
                        d="M197.812 329.531H163.44a8.519 8.519 0 1 1 0-17.038h34.373a8.519 8.519 0 1 1-.001 17.038z"
                        opacity={1}
                        data-original="#fff370"
                    />
                    <path
                        fill="#ff8f33"
                        d="M372.147 310.502v113.043a9.263 9.263 0 0 1-9.263 9.263h-139.56a9.263 9.263 0 0 1-9.263-9.263V310.502a9.263 9.263 0 0 1 9.263-9.263h139.56a9.263 9.263 0 0 1 9.263 9.263z"
                        opacity={1}
                        data-original="#ff8f33"
                    />
                    <path
                        fill="#ffaf40"
                        d="M359.278 301.24c-1.488 67.652-56.796 122.041-124.807 122.041-6.95 0-13.768-.568-20.409-1.661V310.502a9.263 9.263 0 0 1 9.263-9.263h135.953z"
                        opacity={1}
                        data-original="#ffaf40"
                    />
                    <path
                        fill="#ffc751"
                        d="M339.798 301.24c-1.482 56.898-48.074 102.567-105.327 102.567a105.78 105.78 0 0 1-20.409-1.976v-91.328a9.263 9.263 0 0 1 9.263-9.263z"
                        opacity={1}
                        data-original="#ffc751"
                    />
                    <path
                        fill="#fff370"
                        d="M214.062 329.588v35.059c0 6.38 5.171 11.551 11.551 11.551s11.551-5.171 11.551-11.551v-35.059c0-6.38-5.171-11.551-11.551-11.551-6.379 0-11.551 5.172-11.551 11.551z"
                        opacity={1}
                        data-original="#fff370"
                    />
                    <path
                        fill="#79ff79"
                        d="m357.933 411.72-11.3-16.682c-1.917-2.83-6.085-2.83-8.002 0l-11.3 16.682c-2.174 3.209.125 7.543 4.001 7.543h22.599c3.877 0 6.176-4.334 4.002-7.543z"
                        opacity={1}
                        data-original="#79ff79"
                    />
                    <path
                        fill="#29e088"
                        d="M353.931 419.262h-8.96a20.301 20.301 0 0 0 1.928-8.665c0-6.539-3.074-12.357-7.853-16.093 2.054-2.281 5.799-2.107 7.587.532l11.299 16.682c2.175 3.21-.125 7.544-4.001 7.544z"
                        opacity={1}
                        data-original="#29e088"
                    />
                    <path
                        fill="#e0006b"
                        d="M313.125 301.24v34.624c0 5.116-4.15 9.263-9.263 9.263h-21.514a9.259 9.259 0 0 1-9.183-8.071 8.365 8.365 0 0 1-.08-1.192V301.24z"
                        opacity={1}
                        data-original="#e0006b"
                    />
                    <path
                        fill="#fe2582"
                        d="M302.278 311.744c0 14.116-11.443 25.559-25.559 25.559-1.207 0-2.393-.083-3.554-.247a8.365 8.365 0 0 1-.08-1.192V301.24h26.942a25.48 25.48 0 0 1 2.251 10.504z"
                        opacity={1}
                        data-original="#fe2582"
                    />
                    <path
                        fill="#fc70b2"
                        d="M289.042 301.24v15.455a7.977 7.977 0 0 1-7.979 7.979 7.98 7.98 0 0 1-7.979-7.979V301.24z"
                        opacity={1}
                        data-original="#fc70b2"
                    />
                    <path
                        fill="#2b6d6c"
                        d="M412.301 462.936H99.699a6.966 6.966 0 0 1-6.966-6.966v-16.194a6.966 6.966 0 0 1 6.966-6.966H412.3a6.966 6.966 0 0 1 6.966 6.966v16.194a6.965 6.965 0 0 1-6.965 6.966z"
                        opacity={1}
                        data-original="#2b6d6c"
                    />
                    <g fill="#009887">
                        <path
                            d="M294.086 432.808c-6.582 0-11.917 5.336-11.917 11.917 0 6.582 5.336 11.917 11.917 11.917 6.582 0 11.917-5.336 11.917-11.917 0-6.581-5.336-11.917-11.917-11.917zM253.781 432.808h-77.257c-6.582 0-11.917 5.336-11.917 11.917 0 6.582 5.336 11.917 11.917 11.917h77.257c6.582 0 11.917-5.336 11.917-11.917 0-6.581-5.335-11.917-11.917-11.917z"
                            fill="#009887"
                            opacity={1}
                            data-original="#009887"
                        />
                    </g>
                    <path
                        fill="#ffc751"
                        d="M264.744 217.791H141.986a7.519 7.519 0 0 1-7.519-7.519V87.515a7.519 7.519 0 0 1 7.519-7.519h122.757a7.519 7.519 0 0 1 7.519 7.519v122.757a7.518 7.518 0 0 1-7.518 7.519z"
                        opacity={1}
                        data-original="#ffc751"
                    />
                    <path
                        fill="#ffaf40"
                        d="M272.259 110.201v100.065c0 4.155-3.361 7.529-7.516 7.529H160.245c55.498-10.228 99.629-52.877 112.014-107.594z"
                        opacity={1}
                        data-original="#ffaf40"
                    />
                    <path
                        fill="#b55434"
                        d="M252.745 106.811v84.162a7.299 7.299 0 0 1-7.299 7.299h-84.162a7.299 7.299 0 0 1-7.299-7.299v-84.162a7.299 7.299 0 0 1 7.299-7.299h84.162a7.299 7.299 0 0 1 7.299 7.299z"
                        opacity={1}
                        data-original="#b55434"
                    />
                    <path
                        fill="#7f392c"
                        d="M252.745 106.811v84.162a7.299 7.299 0 0 1-7.299 7.299H194.66c27.815-17.354 46.324-48.229 46.324-83.428 0-5.216-.406-10.337-1.19-15.332h5.652a7.299 7.299 0 0 1 7.299 7.299z"
                        opacity={1}
                        data-original="#7f392c"
                    />
                    <path
                        fill="#a1412b"
                        d="M239.795 99.512h-78.511a7.3 7.3 0 0 0-7.299 7.299v2.433h59.479c6.066 0 10.914 5.094 10.559 11.15l-.008.124c-2.621 38.105-31.44 69.007-68.58 74.82v.002a7.284 7.284 0 0 0 5.849 2.932h33.376c27.815-17.354 46.324-48.229 46.324-83.428a98.834 98.834 0 0 0-1.189-15.332z"
                        opacity={1}
                        data-original="#a1412b"
                    />
                    <path
                        fill="#ff8f33"
                        d="M252.74 106.814v11.698l-7.079 7.079-65.581 65.594-7.093 7.093h-11.698a7.302 7.302 0 0 1-7.304-7.304v-11.711l79.753-79.753h11.711c4.022-.001 7.291 3.268 7.291 7.304z"
                        opacity={1}
                        data-original="#ff8f33"
                    />
                    <path
                        fill="#ffaf40"
                        d="m245.66 125.591-65.581 65.594a48.45 48.45 0 0 1-19.015-19.002l65.594-65.594a48.573 48.573 0 0 1 19.002 19.002z"
                        opacity={1}
                        data-original="#ffaf40"
                    />
                    <path
                        fill="#fff370"
                        d="M203.11 99.509h-39.368c-5.388 0-9.757-4.368-9.757-9.757 0-5.388 4.368-9.757 9.757-9.757h39.368c5.388 0 9.757 4.368 9.757 9.757a9.757 9.757 0 0 1-9.757 9.757z"
                        opacity={1}
                        data-original="#fff370"
                    />
                    <path
                        fill="#ffc751"
                        d="M370.014 217.791H247.256a7.519 7.519 0 0 1-7.519-7.519V87.515a7.519 7.519 0 0 1 7.519-7.519h122.757a7.519 7.519 0 0 1 7.519 7.519v122.757a7.518 7.518 0 0 1-7.518 7.519z"
                        opacity={1}
                        data-original="#ffc751"
                    />
                    <path
                        fill="#ffaf40"
                        d="M377.529 110.201v100.065c0 4.155-3.361 7.529-7.516 7.529H265.515c55.498-10.228 99.628-52.877 112.014-107.594z"
                        opacity={1}
                        data-original="#ffaf40"
                    />
                    <path
                        fill="#b55434"
                        d="M358.015 106.811v84.162a7.299 7.299 0 0 1-7.299 7.299h-84.162a7.299 7.299 0 0 1-7.299-7.299v-84.162a7.299 7.299 0 0 1 7.299-7.299h84.162a7.299 7.299 0 0 1 7.299 7.299z"
                        opacity={1}
                        data-original="#b55434"
                    />
                    <path
                        fill="#7f392c"
                        d="M358.015 106.811v84.162a7.299 7.299 0 0 1-7.299 7.299H299.93c27.815-17.354 46.324-48.229 46.324-83.428 0-5.216-.406-10.337-1.19-15.332h5.652a7.299 7.299 0 0 1 7.299 7.299z"
                        opacity={1}
                        data-original="#7f392c"
                    />
                    <path
                        fill="#a1412b"
                        d="M345.065 99.512h-78.511a7.3 7.3 0 0 0-7.299 7.299v2.433h59.479c6.066 0 10.914 5.094 10.559 11.15l-.008.124c-2.621 38.105-31.44 69.007-68.58 74.82v.002a7.284 7.284 0 0 0 5.849 2.932h33.376c27.815-17.354 46.324-48.229 46.324-83.428a98.834 98.834 0 0 0-1.189-15.332z"
                        opacity={1}
                        data-original="#a1412b"
                    />
                    <path
                        fill="#ff8f33"
                        d="M358.01 106.814v11.698l-7.079 7.079-65.581 65.594-7.093 7.093h-11.698a7.302 7.302 0 0 1-7.304-7.304v-11.711l79.753-79.753h11.711c4.022-.001 7.291 3.268 7.291 7.304z"
                        opacity={1}
                        data-original="#ff8f33"
                    />
                    <path
                        fill="#ffaf40"
                        d="m350.93 125.591-65.581 65.594a48.45 48.45 0 0 1-19.015-19.002l65.594-65.594a48.573 48.573 0 0 1 19.002 19.002z"
                        opacity={1}
                        data-original="#ffaf40"
                    />
                    <path
                        fill="#fff370"
                        d="M308.38 99.509h-39.368c-5.388 0-9.757-4.368-9.757-9.757 0-5.388 4.368-9.757 9.757-9.757h39.368c5.388 0 9.757 4.368 9.757 9.757 0 5.389-4.369 9.757-9.757 9.757z"
                        opacity={1}
                        data-original="#fff370"
                    />
                    <path
                        fill="#2b6d6c"
                        d="M412.301 247.923H99.699a6.966 6.966 0 0 1-6.966-6.966v-16.194a6.966 6.966 0 0 1 6.966-6.966H412.3a6.966 6.966 0 0 1 6.966 6.966v16.194a6.965 6.965 0 0 1-6.965 6.966z"
                        opacity={1}
                        data-original="#2b6d6c"
                    />
                    <path
                        fill="#009887"
                        d="M232.782 217.796h-77.257c-6.582 0-11.917 5.336-11.917 11.917 0 6.582 5.336 11.917 11.917 11.917h77.257c6.582 0 11.917-5.336 11.917-11.917.001-6.582-5.335-11.917-11.917-11.917z"
                        opacity={1}
                        data-original="#009887"
                    />
                    <g fill="#2b6d6c">
                        <path
                            d="m6.97 483.233 91.238-53.116 14.083 24.19-91.237 53.117z"
                            fill="#2b6d6c"
                            opacity={1}
                            data-original="#2b6d6c"
                        />
                        <path
                            d="m7.095 383.253 14.084-24.19 91.237 53.116-14.083 24.19z"
                            fill="#2b6d6c"
                            opacity={1}
                            data-original="#2b6d6c"
                        />
                        <path
                            d="m7.023 341.387 91.237-53.116 14.084 24.191-91.238 53.116z"
                            fill="#2b6d6c"
                            opacity={1}
                            data-original="#2b6d6c"
                        />
                        <path
                            d="m7.106 241.449 14.083-24.191 91.238 53.116-14.084 24.191z"
                            fill="#2b6d6c"
                            opacity={1}
                            data-original="#2b6d6c"
                        />
                        <path
                            d="m7.074 199.542 91.238-53.117 14.083 24.192-91.237 53.116z"
                            fill="#2b6d6c"
                            opacity={1}
                            data-original="#2b6d6c"
                        />
                        <path
                            d="m7.116 99.644 14.083-24.19 91.238 53.115-14.083 24.192z"
                            fill="#2b6d6c"
                            opacity={1}
                            data-original="#2b6d6c"
                        />
                        <path
                            d="M7.126 57.696 98.363 4.58l14.084 24.19-91.238 53.117z"
                            fill="#2b6d6c"
                            opacity={1}
                            data-original="#2b6d6c"
                        />
                    </g>
                    <path
                        fill="#009887"
                        d="M18.368 512H10c-5.523 0-10-4.477-10-10V10C0 4.477 4.477 0 10 0h8.368c5.523 0 10 4.477 10 10v492c0 5.523-4.477 10-10 10z"
                        opacity={1}
                        data-original="#009887"
                    />
                    <path
                        fill="#1cc3af"
                        d="M28.368 179.832V73.381c0-7.834-6.35-14.184-14.184-14.184S0 65.547 0 73.381v106.451c0 7.834 6.35 14.184 14.184 14.184 7.833 0 14.184-6.351 14.184-14.184z"
                        opacity={1}
                        data-original="#1cc3af"
                    />
                    <path
                        fill="#009887"
                        d="M109.613 512h-8.368c-5.523 0-10-4.477-10-10V10c0-5.523 4.477-10 10-10h8.368c5.523 0 10 4.477 10 10v492c0 5.523-4.478 10-10 10z"
                        opacity={1}
                        data-original="#009887"
                    />
                    <path
                        fill="#1cc3af"
                        d="M91.245 320.548v53.538c0 7.834 6.35 14.184 14.184 14.184s14.184-6.35 14.184-14.184v-53.538c0-7.834-6.35-14.184-14.184-14.184s-14.184 6.351-14.184 14.184z"
                        opacity={1}
                        data-original="#1cc3af"
                    />
                    <circle
                        cx="14.184"
                        cy="226.862"
                        r="14.184"
                        fill="#1cc3af"
                        opacity={1}
                        data-original="#1cc3af"
                    />
                    <g fill="#2b6d6c">
                        <path
                            d="m399.329 483.375 91.237-53.116 14.084 24.191-91.238 53.116z"
                            fill="#2b6d6c"
                            opacity={1}
                            data-original="#2b6d6c"
                        />
                        <path
                            d="m399.339 383.283 14.083-24.191 91.238 53.116-14.084 24.191z"
                            fill="#2b6d6c"
                            opacity={1}
                            data-original="#2b6d6c"
                        />
                        <path
                            d="m399.38 341.53 91.238-53.116 14.083 24.191-91.237 53.117z"
                            fill="#2b6d6c"
                            opacity={1}
                            data-original="#2b6d6c"
                        />
                        <path
                            d="m399.35 241.478 14.084-24.19 91.237 53.116-14.083 24.19z"
                            fill="#2b6d6c"
                            opacity={1}
                            data-original="#2b6d6c"
                        />
                        <path
                            d="m399.432 199.685 91.237-53.116 14.084 24.19-91.238 53.117z"
                            fill="#2b6d6c"
                            opacity={1}
                            data-original="#2b6d6c"
                        />
                        <path
                            d="m399.36 99.674 14.084-24.191 91.238 53.116-14.084 24.191z"
                            fill="#2b6d6c"
                            opacity={1}
                            data-original="#2b6d6c"
                        />
                        <path
                            d="m399.483 57.84 91.238-53.117 14.083 24.191-91.237 53.117z"
                            fill="#2b6d6c"
                            opacity={1}
                            data-original="#2b6d6c"
                        />
                    </g>
                    <path
                        fill="#009887"
                        d="M410.755 512h-8.368c-5.523 0-10-4.477-10-10V10c0-5.523 4.477-10 10-10h8.368c5.523 0 10 4.477 10 10v492c0 5.523-4.477 10-10 10z"
                        opacity={1}
                        data-original="#009887"
                    />
                    <path
                        fill="#1cc3af"
                        d="M420.755 179.832V73.381c0-7.834-6.35-14.184-14.184-14.184s-14.184 6.35-14.184 14.184v106.451c0 7.834 6.35 14.184 14.184 14.184s14.184-6.351 14.184-14.184z"
                        opacity={1}
                        data-original="#1cc3af"
                    />
                    <path
                        fill="#009887"
                        d="M502 512h-8.368c-5.523 0-10-4.477-10-10V10c0-5.523 4.477-10 10-10H502c5.523 0 10 4.477 10 10v492c0 5.523-4.477 10-10 10z"
                        opacity={1}
                        data-original="#009887"
                    />
                    <path
                        fill="#1cc3af"
                        d="M483.632 320.548v53.538c0 7.834 6.35 14.184 14.184 14.184 7.833 0 14.184-6.35 14.184-14.184v-53.538c0-7.834-6.35-14.184-14.184-14.184-7.833 0-14.184 6.351-14.184 14.184z"
                        opacity={1}
                        data-original="#1cc3af"
                    />
                    <circle
                        cx="406.571"
                        cy="226.862"
                        r="14.184"
                        fill="#1cc3af"
                        opacity={1}
                        data-original="#1cc3af"
                    />
                </g>
            </svg>
        </>
    )
}

export default InventoryManageIcon